<div class="custom-toast-wrapper" [class.visible]="isVisible" [ngClass]="getTypeClass()">
  <div class="toast-content">
    <div class="toast-icon">
      <ion-icon [name]="getIcon()"></ion-icon>
    </div>
    <div class="toast-message">
      {{ toast.message }}
    </div>
    <div class="toast-close" *ngIf="toast.showCloseButton" (click)="dismissToast()">
      <ion-icon name="close-outline"></ion-icon>
    </div>
  </div>
</div> 